export const PLEASE_SELECT_ONE = 'Please Select One';
export const NUMBER_ONLY_REGEX = /[a-zA-Z!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~ ]/;
export const ALPHA_NUMBER_ONLY_REGEX = /[^A-Za-z0-9]/g;
export const CHARACTERS_NONNUMERIC_REGEX = /[0-9]/;
export const NUMBER_REGEX = /^[0-9\b]+$/;
export const AMOUNT = /^[-]?[0-9]{0,9}\.?[0-9]{0,2}$/;
export const BAL_PERCENT_REGEX = /^[0-9]{0,9}(\.[0-9]{0,6})?$/;
export const RX_WITHOUT = /^[0-9]{0,9}?$/;
export const TWO_DECIMAL_REGEX = /^[0-9]{0,9}(\.[0-9]{0,2})?$/;
export const EMAIL_ID_REGEX = /\S+@\S+\.\S+/;
export const DATE_ERROR_1964 =
  'Date must be greater than or equal to 01/01/1964.';
export const SAVE = 'Save';
export const PRINT = 'Print';
export const HELP = 'Help';
export const NOTES = 'Notes';
export const LOB = 'LOB';
export const PAYEE_TYPE = 'Payee Type';
export const PAYEE_ID_TYPE_CODE = 'Payee ID Type Code';
export const PAYEE_ID = 'Payee ID';
export const PAYEE_NAME = 'Payee Name';
export const SYSTEM_PAYEE_ID = 'System Payee ID';
export const ACTIVITY_TYPE = 'Activity Type';
export const PAYMENT_SCHEDULE = 'Payment Schedule';
export const HISTORY = 'History';
export const ATTACHMENT = 'Attachment';
export const REASON_CODE = 'Reason Code';
export const SAVE_SUCCESS = 'System successfully saved the Information.';
export const ERR_PROCESSING_REQ =
  'There was an error processing the request. Please retry the transaction.';
export const MEMBER_ID_TYPE = 'Member ID Type';
export const MEMBER_ID = 'Member ID';
export const MEMBER_NAME = 'Member Name';
export const PAYEE_NAME_NOT_FOUND = 'Payee name not found.';
export const INCORRECT_DATA_FORMAT = 'Data entered is in the incorrect format.';
export const DEFAULT_DATE_ERROR =
  'Default Date can not be prior to todays date.';
export const INCORRECT_FORMAT = 'Please enter the data in correct format.';
export const INVALID_ADDRESS = 'Invalid Service Location Address.';
export const VERIFIED_ADDRESS = 'Please verify or Enter a valid Address.';
// export const DASHBOARD_HEADER_TEXT = 'Department of Human Services';
export const DASHBOARD_HEADER_TEXT = 'CMdS Rebate ';
export const INVOICE_NUM_REQ = 'Invoice Number is required. ';
export const SUCCESS = 'Mailing date updated for Manufacturer Id ';
export const MAILING_DT_SUCCESS =
  'Mailing date and sent date set on all invoices selected for Quarter.(# invoice).';
export const MAILING_DT_SUCCESS_INV = 'Mailing date updated for invoice ';
export const INVOICE_NO_REQ = 'Please enter an Invoice number.';
export const INVOICE_NOT_FOUND = 'Invoice Number not found';
export const SUCCESS_INVOICE =
  'Invoice freeze procedure has been completed successfully.';
export const SUCCESS_ALL_INVOICE =
  'Mailing date and sent date set on all invoices for nQYYYY( n invoices).';
export const NO_RECORDS_FOUND =
  'No results found for the search criteria selected.';
export const QUARTER_FORMAT_ERROR =
  "Please enter a valid quarter and year in '#Q##' or '#Q####' format. Example: '1Q98' or '1Q1998'.";
export const QUARTER_REQUIRED = 'Quarter is required.';
export const REBATE_PGM_REQUIRED = 'Rebate Program is required.';
export const FREEZE_DT_REQ = 'Freeze Date is required.';
export const CMS_REPORTING_GROUP_REQUIRED = 'CMS Reporting Group is required';
export const REQUEST_INVOICE_CALC_SUCCESS =
  'Request Invoice Calculation job completed.';
export const REQUEST_INVOICE_CALC_SUCCESS_LATER =
  'Job has been submitted and will be run tonight.';
export const INVOICE_JOB_COMPLETE = 'Job Complete.';
export const NO_DATA_TO_PRINT = 'No data to print for the Invoice No';
export const INVOICE_JOB_DEFERED = 'Job has been submitted to run deferred.';
export const MANUFACTURER_EMPTY_MSG =
  'Please select a manufacturer or All Manufacturers.';
export const MANUFACTURER_SELECT_MSG = 'Select a Manufacturer ';
export const SELECTION_NOT_MATCH =
  'No results found for the search criteria selected.';
export const ASSIGN_TO_ALL_DEFAULT =
  'System successfully updated the Dispute Information';
export const DOUBLE_CLICK_INFO =
  '* On Double Click of Results, system should navigate to Detail page';
export const DRUG_FAMILY_ROUTE = '/drugfamily';
export const DRUG_DETAIL_ROUTE = '/drugFamilyDetail';
export const VIEW_DRUG_FAMILY_DETAIL = 'View Drug Family Detail';
export const VIEW_DRUG_FAMILY_DETAIL_MGS =
  'This will set the Drug Family Specific Therapeutic Class to MULTIPLE';
export const MULTIPLE_MANUFACTURER_POPUP =
  'This will set the Drug Family Manufacturer to MULTIPLE';
export const NO_MANUFACTURER_FOUND = 'Manufacturer not found for';
export const MULTIPLE_MFG_FOUND = 'Multiple Manufacturer found for';
export const ASSIGN_STARTDATE_SUCCESS =
  'Start dates have been successfully updated!';
export const NO_STARTDATE_ERROR = 'Please add a start date!';
export const NDC = 'NDC';
export const Name = 'Name';
export const Labeler = 'Labeler';
export const NDC_FORMAT_MSG =
  'Please enter NDC as  valid format e.g. 00000-0000-00';
export const DRUG_FAMILY_ID = 'DRUG_FAMILY';
export const MANUFACTURER_ID = 'MANUFACTURER';
export const SPECIFIC_THERAPEUTIC_CLASS_ID = 'SPECIFIC_THERAPEUTIC_CLASS';
export const SPECIFIC_DRUG_ID = 'SPECIFIC_DRUG';
export const MARKET_BASKET_ID = 'MARKET_BASKET';
export const CREATE_NEW_ID = 'CREATE_NEW';
export const DRUG_FAMILY = 'Drug Family';
export const MANUFACTURER = 'Manufacturer';
export const SPECIFIC_THERAPEUTIC_CLASS = 'Specific Therapeutic Class';
export const SPECIFIC_DRUG = 'Specific Drug';
export const MARKET_BASKET = 'Market Basket';
export const CREATE_NEW = 'Create New';
export const DRUG_FAMILY_POPUP_TITLE =
  'Select Specific Market Basket/Drug Family';
export const VALID_NDC_MSG = 'Enter a valid NDC Name';
export const CANDIDATE_DRUGS = 'Candidate Drugs';
export const SELECTED_DRUGS = 'Selected Drugs';
export const DRUG_FAMILY_NULL_ERR =
  'Please select a different drug. Drug: {NDC} selected has no associated drug families';
export const VALID_NDC_ERR =
  'Please enter NDC in the format XXXXX-XXXX-XX or XXXXXXXXXXX.';
export const DRUG_SELECTION_NULL_ERR = 'Please select a drug to search.';
export const GRID_HEIGHT = '340px';
export const DRUG_NAME = 'Drug Name';
export const DRUG_NAME_REQUIRED = 'Drug Name is required.';
export const GENERIC_CODE = 'Generic Code';
export const GCN = 'GCN Sequence Number';
export const MFG_REQ = 'You must choose a Manufacturer.';
export const INVOICE_UNFREEZE_SUCCESS = 'Invoice Unfreeze Successful.';
export const REMOVE_SUSPENDED_SUCCESS =
  'Removal of Suspended Data was Successful.';
export const NO_MATHING_INVOICE =
  'There are no invoices matching that criteria.';
export const NO_MFG_CHOSEN_ERR =
  'You must choose a Manufacturer or select All.';
export const CHECK_LOG_NO_REQ = 'Check Log Number is required.';
export const SUSPENDED_DT_REM_SUCCESS = 'Suspended Date removed Successfully.';
export const NO_DATA_PRINT = 'No data to print.';
export const REBATE_PGM_REQ = 'Rebate Program is required.';
export const PLAN_TYPE_REQUIRED = 'Plan Type is required.';
// Contract
export const MANUFACTURER_REBATE = 'Manufacturer / Rebate Program';
export const MANUFACTURER_REBATE_ID = 'MF';
export const CONTRACT = 'Contract';
export const CONTRACT_ID = 'CONTRACT_ID';
export const PLAN_TYPE = 'Plan Type';
export const CONTRACT_DRUG_FAMILTY_ID = 'DF';
export const CONTRACT_MARKET_BASKET_ID = 'MB';
export const SEARCH_CONTRACT_ID = 'C';
export const MARKET_BASKET_CONTRACT = 'Market Basket';
export const ERROR_COUNT_FOOTER_MSG =
  'Press OK to proceed with remaining selections or Cancel to stop now.';
export const SELECT_DRUG_FAMILY = 'Select drug family';
export const INVALID_DATE_FORMAT = 'Invalid date format.';
export const COMMON_INCONSISTENCY_RPT = 'Display ROSI/PQAS Inconsistencies Rpt';
export const MFG_REQ_TO_SELECT =
  'You must choose a Manufacturer or select All Manufacturer.';
export const CHILDREN_COMMON_INCONSISTENCY_RPT =
  'Cannot navigate to Invoice QTR or beyond.';
export const allocatePaymentPopUp = 'ROSI/PQAS';
export const noInvoiceQtr = 'There is no invoice for quarter';
export const SESSION_EXPIRY_MSG =
  'Your session is about to expire. Do you want to continue with this session?';
export const ANIMATE_TITLE = 'Session About To Expire!';
export const USER_DEFAULT_INFO =
  'Rebate system may not function properly until you have saved  the default plan type. Please save your default settings before you proceed. Remember you may change the default settings by selecting User default menu from System.';
